import { DocumentCheckIcon } from '@heroicons/react/24/outline';
import CT from '@marketplace-ai/tags';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { paths } from '~/routing';
import { getHlxNavIcon } from '~/routing/hlxNavIcons';
import { API_CALLS } from '../api';
import { ContractSummary } from '../types';

const TAGS = CT.employer.contracts.contractList;

// [MCV-1516] Match the left sidebar's icon for this destination.
export const ContractsIcon = getHlxNavIcon(paths.hlx.contracts) ?? DocumentCheckIcon;

export const ContractsSummaryCard = () => {
  const navigate = useNavigate();
  const [summary, setSummary] = useState<ContractSummary | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API_CALLS.getSummary()
      .then(setSummary)
      .catch((err) => {
        console.debug('ContractsSummaryCard: failed to load summary', err);
        setSummary(null);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-grey-900 p-6 animate-pulse">
        <div className="h-5 bg-grey-900 rounded w-1/3 mb-4" />
        <div className="grid grid-cols-3 gap-4">
          <div className="h-12 bg-grey-900 rounded" />
          <div className="h-12 bg-grey-900 rounded" />
          <div className="h-12 bg-grey-900 rounded" />
        </div>
      </div>
    );
  }

  if (!summary) return null;

  return (
    <button
      type="button"
      className="bg-white rounded-xl shadow-sm border border-grey-900 p-6 w-full text-left hover:shadow-md transition-shadow"
      onClick={() => navigate(paths.hlx.contracts)}
      data-cy={TAGS.summaryCard}
    >
      <div className="flex items-center gap-2 mb-4">
        <ContractsIcon className="size-5 text-primary-50" />
        <h3 className="sub-heading-sb text-grey-100">Contracts</h3>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div>
          <p className="text-2xl font-bold text-primary-50">{summary.active}</p>
          <p className="body-text text-grey-500">Active</p>
        </div>
        <div>
          <p className="text-2xl font-bold text-warning">{summary.upcoming}</p>
          <p className="body-text text-grey-500">Upcoming</p>
        </div>
        <div>
          <p className="text-2xl font-bold text-grey-300">{summary.pastThisYear}</p>
          <p className="body-text text-grey-500">Past (Year)</p>
        </div>
      </div>
      {summary.totalActiveValue && (
        <div className="mt-4 pt-4 border-t border-grey-900">
          <p className="body-text text-grey-500">Total Active Value</p>
          <p className="text-lg font-semibold">
            ${Number(summary.totalActiveValue).toLocaleString()}
          </p>
        </div>
      )}
    </button>
  );
};
